import type { Site } from "@/models/site"

export type SiteShellAccess =
  | { status: "loading" }
  | { status: "unavailable" }
  | { site: Site; status: "ready" }

interface ResolveSiteShellAccessOptions {
  activeOrganizationId: string | undefined
  siteData: Site | null | undefined
  siteIsFetched: boolean
}

/**
 * Single access decision for the site shell.
 *
 * Trusts `useGetSite`: React Query keys by siteId, so `siteData` is never a
 * previous site while a new siteId is loading (no keepPreviousData).
 */
export const resolveSiteShellAccess = ({
  activeOrganizationId,
  siteData,
  siteIsFetched,
}: ResolveSiteShellAccessOptions): SiteShellAccess => {
  if (!siteIsFetched) {
    return { status: "loading" }
  }

  if (!siteData || siteData.organization?.id !== activeOrganizationId) {
    return { status: "unavailable" }
  }

  return { site: siteData, status: "ready" }
}
